import React, { useState } from "react";
import { Router } from "@reach/router";
import {
  PrivacySection,
  QuoteLayout,
  Thankyou,
} from "../../components/utility/quote";
import { Product_Quote_Routes } from "../../data/Routes";
import HardwareContext from "../../contexts/hardwareContext";
import firebase from "gatsby-plugin-firebase";
import Question1 from "./Question1";
import Question2 from "./Question2";
import Question3 from "./Question3";
import Form from "./Form";
import { ServicesMenuSection } from "../../components/containers/ServicesMenuSection";
import { Footer } from "../../components/utility";
import GtagCode from "../../data/GtagCode";

const Quote = () => {
  const [que1, setQue1] = useState(null);
  const [que2, setQue2] = useState(null);
  const [que3, setQue3] = useState(null);
  const [formValues, setFormValues] = useState(null);

  const addLeadToBackend = async (values) => {
    fetch("/.netlify/functions/sendgrid", {
      method: "POST",
      body: JSON.stringify({
        email: "hitesh.patel@icthub.com.au",
        subject: "New lead recived!!",
        name: values.fullname,
      }),
    });
    var timestamp = firebase.firestore.FieldValue.serverTimestamp();
    await firebase.firestore().collection("IT_Hardware").add({
      customerDetails: values,
      "What type of service do you require?": que1,
      "How many users on the network?": que2,
      "What is your project timeframe?": que3,
      Lead_Generated: timestamp,
    });
    try {
      const response = fetch("/.netlify/functions/sendgrid", {
        method: "POST",
        body: JSON.stringify({
          email: values.email,
          subject: "Digital Comparison",
          name: values.fullname,
        }),
      });
      if (!response.ok) {
        //not 200 response
        return;
      }
    } catch (e) {
      //error
      console.log(e);
    }
  };
  return (
    <QuoteLayout>
      <GtagCode />
      <HardwareContext.Provider
        value={{
          que1,
          setQue1,
          que2,
          setQue2,
          que3,
          setQue3,
          formValues,
          setFormValues,
          addLeadToBackend,
        }}
      >
        <Router>
          <section path={Product_Quote_Routes.ITHardware}>
            <Question1 title="IT Hardware" path="/" />
            <Question2 title="IT Hardware" path="/2" />
            <Question3 title="IT Hardware" path="/3" />
            <Form title="IT Hardware" path="/4" />
            <Thankyou title="IT Hardware" path="/thankyou" />
          </section>
        </Router>
      </HardwareContext.Provider>
      <PrivacySection />
      <ServicesMenuSection />
      <Footer />
    </QuoteLayout>
  );
};

export default Quote;
